import React from 'react';

type Props = {
  label: string;
  value: string | number;
  sub?: string;
  valueColor?: string;
  onClick?: () => void;
};

// Dashboard KPI tile: small uppercase label, large value, one-line note. Matches the Ticket and Projects dashboards.
const KpiCard = ({ label, value, sub, valueColor, onClick }: Props) => (
  <div
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
    onClick={onClick}
    onKeyDown={(event) => {
      if (onClick && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();

        onClick();
      }
    }}
    style={{
      background: 'var(--ant-color-bg-container)',
      border: '1px solid var(--ant-color-border)',
      borderRadius: 10,
      padding: '12px 14px',
      boxShadow: '0 1px 2px rgba(0,0,0,.05), 0 4px 12px rgba(0,0,0,.04)',
      minWidth: 0,
      cursor: onClick ? 'pointer' : 'default',
    }}
  >
    <div
      style={{
        fontSize: 10.5,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        color: 'var(--ant-color-text-secondary)',
        fontWeight: 600,
      }}
    >
      {label}
    </div>
    <div
      style={{
        fontSize: 26,
        fontWeight: 700,
        color: valueColor ?? 'var(--ant-color-text)',
        marginTop: 4,
        lineHeight: 1,
        fontVariantNumeric: 'tabular-nums',
      }}
    >
      {value}
    </div>
    {sub && (
      <div
        style={{
          fontSize: 11,
          color: 'var(--ant-color-text-secondary)',
          marginTop: 6,
        }}
      >
        {sub}
      </div>
    )}
  </div>
);

export default KpiCard;
